/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { ComunicazioneAnteprimaDTO } from '../schemas/comunicazioneAnteprimaDTO.ts';
import type { ComunicazioneDTO } from '../schemas/comunicazioneDTO.ts';
import type { ComunicazioneRequest } from '../schemas/comunicazioneRequest.ts';
import type { CreaAllegatoResponse } from '../schemas/creaAllegatoResponse.ts';
import type { GetFrontRichiesteV2IdComunicazioniParams } from '../schemas/getFrontRichiesteV2IdComunicazioniParams.ts';
import type { PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody } from '../schemas/postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody.ts';
import type { WsRispostaPaginataListComunicazioneDTO } from '../schemas/wsRispostaPaginataListComunicazioneDTO.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * @summary Crea un nuovo allegato, ancora non associato a nessuna comunicazione
 */
export const postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegati = (
  idRichiesta: string,
  idTipoComunicazione: string,
  idTipoAllegato: string,
  postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody: PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append(
    'file',
    postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody.file,
  );

  return apiClientRequest<CreaAllegatoResponse>(
    {
      url: `/framework-cmp-domande/richieste/v2/${idRichiesta}/tipi-comunicazione/${idTipoComunicazione}/tipi-allegato/${idTipoAllegato}/allegati`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegati
        >
      >,
      TError,
      {
        idRichiesta: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegati
      >
    >,
    TError,
    {
      idRichiesta: string;
      idTipoComunicazione: string;
      idTipoAllegato: string;
      data: PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
    },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegati
        >
      >,
      {
        idRichiesta: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
      }
    > = props => {
      const { idRichiesta, idTipoComunicazione, idTipoAllegato, data } =
        props ?? {};

      return postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegati(
        idRichiesta,
        idTipoComunicazione,
        idTipoAllegato,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegati
      >
    >
  >;
export type PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationBody =
  PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
export type PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationError =
  ErrorType<unknown>;

/**
 * @summary Crea un nuovo allegato, ancora non associato a nessuna comunicazione
 */
export const usePostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegati =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegati
        >
      >,
      TError,
      {
        idRichiesta: string;
        idTipoComunicazione: string;
        idTipoAllegato: string;
        data: PostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }) => {
    const mutationOptions =
      getPostFrontRichiesteV2IdTipiComunicazioneIdTipiAllegatoIdAllegatiMutationOptions(
        options,
      );

    return useMutation(mutationOptions);
  };
/**
 * Se l'idComunicazione è vuoto si creerà una nuova comunicazione. Se valorizzato si andrà a operare sulla comunicazione a cui fa riferimento.
 * @summary Crea, salva o modifica una comunicazione
 */
export const postFrontRichiesteV2IdComunicazioni = (
  idRichiesta: string,
  comunicazioneRequest: ComunicazioneRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<ComunicazioneDTO>(
    {
      url: `/framework-cmp-domande/richieste/v2/${idRichiesta}/comunicazioni`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: comunicazioneRequest,
    },
    options,
  );
};

export const getPostFrontRichiesteV2IdComunicazioniMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioni>>,
    TError,
    { idRichiesta: string; data: ComunicazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioni>>,
  TError,
  { idRichiesta: string; data: ComunicazioneRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioni>>,
    { idRichiesta: string; data: ComunicazioneRequest }
  > = props => {
    const { idRichiesta, data } = props ?? {};

    return postFrontRichiesteV2IdComunicazioni(
      idRichiesta,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteV2IdComunicazioniMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioni>>
>;
export type PostFrontRichiesteV2IdComunicazioniMutationBody =
  ComunicazioneRequest;
export type PostFrontRichiesteV2IdComunicazioniMutationError =
  ErrorType<unknown>;

/**
 * @summary Crea, salva o modifica una comunicazione
 */
export const usePostFrontRichiesteV2IdComunicazioni = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioni>>,
    TError,
    { idRichiesta: string; data: ComunicazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteV2IdComunicazioniMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Invia la comunicazione e la protocolla se il tipoComunicazione associato lo prevede
 */
export const postFrontRichiesteV2IdComunicazioniIdInvia = (
  idRichiesta: string,
  idComunicazione: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<ComunicazioneDTO>(
    {
      url: `/framework-cmp-domande/richieste/V2/${idRichiesta}/comunicazioni/${idComunicazione}/invia`,
      method: 'post',
    },
    options,
  );
};

export const getPostFrontRichiesteV2IdComunicazioniIdInviaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioniIdInvia>>,
    TError,
    { idRichiesta: string; idComunicazione: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioniIdInvia>>,
  TError,
  { idRichiesta: string; idComunicazione: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioniIdInvia>>,
    { idRichiesta: string; idComunicazione: string }
  > = props => {
    const { idRichiesta, idComunicazione } = props ?? {};

    return postFrontRichiesteV2IdComunicazioniIdInvia(
      idRichiesta,
      idComunicazione,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFrontRichiesteV2IdComunicazioniIdInviaMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioniIdInvia>>
  >;

export type PostFrontRichiesteV2IdComunicazioniIdInviaMutationError =
  ErrorType<unknown>;

/**
 * @summary Invia la comunicazione e la protocolla se il tipoComunicazione associato lo prevede
 */
export const usePostFrontRichiesteV2IdComunicazioniIdInvia = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFrontRichiesteV2IdComunicazioniIdInvia>>,
    TError,
    { idRichiesta: string; idComunicazione: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostFrontRichiesteV2IdComunicazioniIdInviaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Ricerca paginata delle Comunicazioni a livello di Richiesta
 */
export const getFrontRichiesteV2IdComunicazioni = (
  id: string,
  params?: GetFrontRichiesteV2IdComunicazioniParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListComunicazioneDTO>(
    {
      url: `/framework-cmp-domande/richieste/v2/${id}/comunicazioni`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteV2IdComunicazioniQueryKey = (
  id: string,
  params?: GetFrontRichiesteV2IdComunicazioniParams,
) =>
  [
    `/framework-cmp-domande/richieste/v2/${id}/comunicazioni`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteV2IdComunicazioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteV2IdComunicazioni>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteV2IdComunicazioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteV2IdComunicazioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteV2IdComunicazioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteV2IdComunicazioniQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteV2IdComunicazioni>>
  > = ({ signal }) =>
    getFrontRichiesteV2IdComunicazioni(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetFrontRichiesteV2IdComunicazioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteV2IdComunicazioni>>
>;
export type GetFrontRichiesteV2IdComunicazioniQueryError = ErrorType<unknown>;

/**
 * @summary Ricerca paginata delle Comunicazioni a livello di Richiesta
 */
export const useGetFrontRichiesteV2IdComunicazioni = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteV2IdComunicazioni>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetFrontRichiesteV2IdComunicazioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteV2IdComunicazioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteV2IdComunicazioniQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Crea una anteprima della Comunicazione per la Richiesta con popolati oggetto e messaggio
 */
export const getFrontRichiesteV2IdTipiComunicazioneIdAnteprima = (
  idRichiesta: string,
  idTipoComunicazione: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ComunicazioneAnteprimaDTO>(
    {
      url: `/framework-cmp-domande/richieste/v2/${idRichiesta}/tipi-comunicazione/${idTipoComunicazione}/anteprima`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteV2IdTipiComunicazioneIdAnteprimaQueryKey = (
  idRichiesta: string,
  idTipoComunicazione: string,
) =>
  [
    `/framework-cmp-domande/richieste/v2/${idRichiesta}/tipi-comunicazione/${idTipoComunicazione}/anteprima`,
  ] as const;

export const getGetFrontRichiesteV2IdTipiComunicazioneIdAnteprimaQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getFrontRichiesteV2IdTipiComunicazioneIdAnteprima>
    >,
    TError = ErrorType<unknown>,
  >(
    idRichiesta: string,
    idTipoComunicazione: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof getFrontRichiesteV2IdTipiComunicazioneIdAnteprima>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<typeof getFrontRichiesteV2IdTipiComunicazioneIdAnteprima>
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFrontRichiesteV2IdTipiComunicazioneIdAnteprimaQueryKey(
        idRichiesta,
        idTipoComunicazione,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getFrontRichiesteV2IdTipiComunicazioneIdAnteprima>
      >
    > = ({ signal }) =>
      getFrontRichiesteV2IdTipiComunicazioneIdAnteprima(
        idRichiesta,
        idTipoComunicazione,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(idRichiesta && idTipoComunicazione),
      ...queryOptions,
    };
  };

export type GetFrontRichiesteV2IdTipiComunicazioneIdAnteprimaQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getFrontRichiesteV2IdTipiComunicazioneIdAnteprima>
    >
  >;
export type GetFrontRichiesteV2IdTipiComunicazioneIdAnteprimaQueryError =
  ErrorType<unknown>;

/**
 * @summary Crea una anteprima della Comunicazione per la Richiesta con popolati oggetto e messaggio
 */
export const useGetFrontRichiesteV2IdTipiComunicazioneIdAnteprima = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteV2IdTipiComunicazioneIdAnteprima>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idTipoComunicazione: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteV2IdTipiComunicazioneIdAnteprima>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteV2IdTipiComunicazioneIdAnteprimaQueryOptions(
      idRichiesta,
      idTipoComunicazione,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
